import React from "react";

export default function Disclaimer(props) {
  return (
    <div
      style={{
        display: "flex",
        width: "80%",
        margin: "0 auto",
      }}
    >
      <input
        type="checkbox"
        name={props.name}
        style={{
          marginBottom: "20px",
          marginRight: "10px",
        }}
        onChange={props.onChange}
        checked={props.value}
      />
      <p style={{ textAlign: "left" }}>
        * By submitting this form, you acknowledge that we may use your personal information for marketing
        communications.
      </p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Forms/Disclaimer.js